var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.15625,
  y: 0.820312,
  width: 24,
  height: 24,
  rx: 8,
  fill: "#F1F9FF"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4683_20381)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.1563 7.44531C12.299 7.44531 12.4293 7.52634 12.4925 7.65433L13.9504 10.6077L17.2105 11.0843C17.3517 11.1049 17.469 11.2039 17.513 11.3396C17.557 11.4754 17.5201 11.6244 17.4179 11.7239L15.0592 14.0213L15.6159 17.2669C15.64 17.4076 15.5822 17.5498 15.4667 17.6337C15.3512 17.7176 15.1981 17.7287 15.0717 17.6622L12.1563 16.129L9.24081 17.6622C9.11446 17.7287 8.96135 17.7176 8.84586 17.6337C8.73037 17.5498 8.67253 17.4076 8.69666 17.2669L9.25332 14.0213L6.89461 11.7239C6.79238 11.6244 6.75553 11.4754 6.79954 11.3396C6.84356 11.2039 6.96082 11.1049 7.10203 11.0843L10.3622 10.6077L11.82 7.65433C11.8832 7.52634 12.0135 7.44531 12.1563 7.44531ZM12.1563 8.66753L10.9475 11.1163C10.8929 11.2269 10.7875 11.3035 10.6655 11.3214L7.96192 11.7165L9.91791 13.6217C10.0064 13.7078 10.0467 13.832 10.0259 13.9537L9.56433 16.6447L11.9817 15.3734C12.091 15.3159 12.2215 15.3159 12.3308 15.3734L14.7482 16.6447L14.2867 13.9537C14.2658 13.832 14.3062 13.7078 14.3946 13.6217L16.3506 11.7165L13.647 11.3214C13.525 11.3035 13.4196 11.2269 13.365 11.1163L12.1563 8.66753Z",
  fill: "#00538F"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4683_20381"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  fill: "white",
  transform: "translate(6.15625 6.82031)"
})));

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.00f1d945.svg";
export { ForwardRef as ReactComponent };